import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
import { Form, Row, Col, Button, Input, Select, Space, Table } from 'antd'
import {
  PlusCircleOutlined,
  ToolFilled,
  CloseCircleOutlined,
  PlayCircleOutlined,
  PauseCircleOutlined,
  LinkOutlined,
  EllipsisOutlined,
} from '@ant-design/icons'
import history from '../../routes/history';
import * as AppUrl from '../../constants/appUrl'
import { getPaginationConfig } from '../../components/pagination';

const { Item } = Form
const { Option } = Select
const { Column } = Table;

@inject('messageManagementStore')
@observer
class IndexSearch extends Component {

	state={
    selectedRowKeys: [],
  }

  handleMessageManagement = () => {
    history.push(AppUrl.MESSAGEMANAGEMENT)
  }

	handlePageChange = (page, pageSize) => {
    const { messageManagementStore } = this.props
    messageManagementStore.onChangePageNumAction(page, pageSize || 10)
  }

	onSelectChange = selectedRowKeys => {
    this.setState({ selectedRowKeys });
  }

  render() {
		const { messageManagementStore } = this.props
    const { pageNo, pageSize, itemCount, messageList } = messageManagementStore
		const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange);
    const { selectedRowKeys } = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
    return (
      <>
        <Form labelAlign="left" labelCol={{ span: 8 }}  size='small'>
          <Row>
            <Col span={12}>
              <Item name='name' label='Name'>
                <Input style={{ width: 200 }} allowClear />
              </Item>
            </Col>
            <Col span={6} offset={6}>
              <Space>
                <Button type='primary'>Search</Button>
                <Button onClick={this.handleMessageManagement} type='primary'>Message Management</Button>
              </Space>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Item name='apiIntegrationScenaria' label='API Integration Scenaria'>
                <Select
									allowClear
                  defaultValue="0"
                  style={{ width: 200 }}
                >
                  <Option value="1">1</Option>
                  <Option value="2">2</Option>
                  <Option value="3">3</Option>
                </Select>
              </Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Item name='apiService' label='API Service'>
                <Select
									allowClear
                  defaultValue="0"
                  style={{ width: 200 }}
                >
                  <Option value="1">1</Option>
                  <Option value="2">2</Option>
                  <Option value="3">3</Option>
                </Select>
              </Item>
            </Col>
            <Col span={12}>
              <Item name='apiServiceOperation' label='API Service Operation'>
                <Select
									allowClear
                  defaultValue="0"
                  style={{ width: 200 }}
                >
                  <Option value="1">1</Option>
                  <Option value="2">2</Option>
                  <Option value="3">3</Option>
                </Select>
              </Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Item name='sender' label='Sender'>
                <Select
									allowClear
                  defaultValue="0"
                  style={{ width: 200 }}
                >
                  <Option value="1">1</Option>
                  <Option value="2">2</Option>
                  <Option value="3">3</Option>
                </Select>
              </Item>
            </Col>
            <Col span={12}>
              <Item name='receiver' label='Receiver'>
                <Select
									allowClear
                  defaultValue="0"
                  style={{ width: 200 }}
                >
                  <Option value="1">1</Option>
                  <Option value="2">2</Option>
                  <Option value="3">3</Option>
                </Select>
              </Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Item name='senderComponent' label='Sender Component'>
                <Select
									allowClear
                  defaultValue="0"
                  style={{ width: 200 }}
                >
                  <Option value="1">1</Option>
                  <Option value="2">2</Option>
                  <Option value="3">3</Option>
                </Select>
              </Item>
            </Col>
            <Col span={12}>
              <Item name='receiverComponent' label='Receiver Component'>
                <Select
									allowClear
                  defaultValue="0"
                  style={{ width: 200 }}
                >
                  <Option value="1">1</Option>
                  <Option value="2">2</Option>
                  <Option value="3">3</Option>
                </Select>
              </Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Item name='createBy' label='Create By'>
                <Select
									allowClear
                  defaultValue="0"
                  style={{ width: 200 }}
                >
                  <Option value="1">1</Option>
                  <Option value="2">2</Option>
                  <Option value="3">3</Option>
                </Select>
              </Item>
            </Col>
            <Col span={12}>
              <Item name='changeBy' label='Change By'>
                <Select
									allowClear
                  defaultValue="0"
                  style={{ width: 200 }}
                >
                  <Option value="1">1</Option>
                  <Option value="2">2</Option>
                  <Option value="3">3</Option>
                </Select>
              </Item>
            </Col>
          </Row>
        </Form>
        <Space size='middle' style={{margin:'20px 0 0 0'}}>
          <PlusCircleOutlined style={{color:'#012A73', fontSize:'20px'}} onClick={() => alert('11111')} />
          <ToolFilled style={{color:'#012A73', fontSize:'20px'}} onClick={() => alert('11111')} />
          <CloseCircleOutlined style={{color:'#012A73', fontSize:'20px'}} onClick={() => alert('11111')} />
          <PlayCircleOutlined style={{color:'#012A73', fontSize:'20px'}} onClick={() => alert('11111')} />
          <PauseCircleOutlined style={{color:'#012A73', fontSize:'20px'}} onClick={() => alert('11111')} />
          <LinkOutlined style={{color:'#012A73', fontSize:'20px'}} onClick={() => alert('11111')} />
          <EllipsisOutlined style={{color:'#012A73', fontSize:'20px'}} onClick={() => alert('11111')} />
        </Space>
        <Table scroll={{ y: 290 }} tableLayout='fixed' rowSelection={rowSelection} dataSource={messageList} pagination={pagination} rowKey="id" size="small" >
					<Column title='Name' dataIndex="name" />
					<Column title='Description' dataIndex="description" />
					<Column title='Status' dataIndex="status" />
					<Column title='XPath' dataIndex="xPath" />
					<Column title='Sender' dataIndex="sender" />
					<Column title='Sender Component' dataIndex="senderComponent" />
					<Column title='Receiver' dataIndex="receiver" />
					<Column title='Receiver Component' dataIndex="receiverComponent" />
					<Column title='API Integration Scenaria' dataIndex="apiIntegrationScenaria" />
					<Column title='API Service' dataIndex="apiService" />
					<Column title='API Service Namespace' dataIndex="apiServiceNamespace" render={text => <a>{text}</a>} />
					<Column title='API Service Operation' dataIndex="apiServiceOperation" />
					<Column title='Create By' dataIndex="createBy" />
					<Column title='Last Change By' dataIndex="lastChangeBy" />
				</Table>
      </>
    )
  }
}
export default IndexSearch
